import { render } from "./NewPush.vue?vue&type=template&id=4f4ef7ea"
import script from "./NewPush.vue?vue&type=script&lang=js"
export * from "./NewPush.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__